import PropTypes from 'prop-types';
import {ButtonSwitch, ButtonSwitchOption} from '@gisatcz/ptr-atoms';
import {
	ControlGroup,
	ControlGroupContent,
	ControlGroupLabel,
	ControlGroupLabelGroup,
	ControlGroupWarning,
} from '../components';

import './style.scss';

const TypeControl = ({types, setActiveType, activeTypeKey}) => {
	return (
		<ControlGroup>
			<ControlGroupLabelGroup>
				<ControlGroupLabel className="primary">
					Projected direction (L2)
				</ControlGroupLabel>
				<ControlGroupLabel className="primary">
					Calibration using GPS up component
				</ControlGroupLabel>
				<ControlGroupLabel className="alt">Type</ControlGroupLabel>
			</ControlGroupLabelGroup>
			<ControlGroupContent>
				<ButtonSwitch
					className="dividedAfterNthOption extended"
					onClick={setActiveType}
					ghost
				>
					{types.map(type => (
						<ButtonSwitchOption
							key={type.key}
							value={type.key}
							active={type.key === activeTypeKey}
						>
							{type.data.nameDisplay}
						</ButtonSwitchOption>
					))}
				</ButtonSwitch>
			</ControlGroupContent>
			{activeTypeKey === 'vertggps' ? (
				<ControlGroupWarning>
					Warning: Records from only 1 GNSS station (SAMO) were used for
					calibration. Calibrated motion rates could be biased in other parts of
					the island.
				</ControlGroupWarning>
			) : null}
		</ControlGroup>
	);
};

TypeControl.propTypes = {
	types: PropTypes.array,
	setActiveType: PropTypes.func,
	activeTypeKey: PropTypes.string,
};

export default TypeControl;
